module.exports = __webpack_public_path__ + "static/Axiforma-Bold-b0f0edd25081ec171eae81120a413b98.woff2";